import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { PDC_SPAS_PRODUCTS } from '../data/pdcSpas';
import { PDCProductCard } from './pdcSpaParts';

/**
 * Renders a "PDC Spas" section (heading + product grid) for a single category,
 * for embedding on the existing category pages (Hot Tubs, Swim Spas, Cold Plunge).
 * Each card links to that product's own detail page.
 */
const PDCProductSection = ({ category, heading, blurb }) => {
  const products = useMemo(
    () => PDC_SPAS_PRODUCTS.filter((p) => p.category === category),
    [category]
  );

  if (products.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="mb-16"
      data-testid={`pdc-section-${category}`}
    >
      <h2 className="font-['Barlow_Condensed'] text-3xl font-bold uppercase text-[#0E3D95] mb-2 pb-2 border-b-2 border-[#F88200]">
        {heading || 'PDC Spas'}
      </h2>
      {blurb && <p className="text-slate-600 mb-6 max-w-3xl">{blurb}</p>}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {products.map((p) => (
          <PDCProductCard key={p.id} product={p} />
        ))}
      </div>
    </motion.div>
  );
};

export default PDCProductSection;
